import {
  PERSONAL_PROJECT_SCOPE,
  type ProjectOrganizationScope,
} from "@/features/projects/types";

export const API_KEYS_QUERY_KEY = ["apiKeys"] as const;

export type ApiKeyListScope = {
  principalId: string;
  organizationId: ProjectOrganizationScope;
};

export type ApiKeyListParams = {
  page: number;
  pageSize: number;
  projectIds?: string[];
};

export const apiKeyQueryKeys = {
  all: API_KEYS_QUERY_KEY,
  lists: () => [...apiKeyQueryKeys.all, "list"] as const,
  listScope: (scope: ApiKeyListScope) =>
    [
      ...apiKeyQueryKeys.lists(),
      scope.principalId,
      scope.organizationId || PERSONAL_PROJECT_SCOPE,
    ] as const,
  list: (scope: ApiKeyListScope, params: ApiKeyListParams) =>
    [
      ...apiKeyQueryKeys.listScope(scope),
      {
        page: params.page,
        pageSize: params.pageSize,
        projectIds: [...(params.projectIds ?? [])],
      },
    ] as const,
};

export const isApiKeyListKeyInScope = (
  queryKey: readonly unknown[],
  scope: ApiKeyListScope,
) => {
  const scopeKey = apiKeyQueryKeys.listScope(scope);
  return scopeKey.every((part, index) => queryKey[index] === part);
};
